export const defaultArea = 'default-area';